import mediator, { ACTIONS } from '../mediator';
import svgClasses from '../lib/common/svgClasses';
import { reject, forEach } from 'lodash';

const CLASS_NAMES = {
  active: 'syos-screen--active',
  hidden: 'syos-screen--hidden'
};

const excludeCurrent = (needle, haystack) =>
  reject(haystack, item => item === needle);

export default function(svgEl) {
  let allScreens = svgEl.querySelectorAll("[id^='syos-screen-']");
  mediator.subscribe(ACTIONS.SCREEN_FILTER_SELECTED, function(payload) {
    let selected = payload.selected;
    if (selected.length) {
      let selectedScreenEl = svgEl.querySelector(`#syos-screen-${selected}`);
      if (allScreens.length && selectedScreenEl) {
        let otherScreens = excludeCurrent(selectedScreenEl, allScreens);
        forEach(otherScreens, function(screenEl) {
          svgClasses.removeClass(screenEl, CLASS_NAMES.active);
          svgClasses.addClass(screenEl, CLASS_NAMES.hidden);
        });

        svgClasses.removeClass(selectedScreenEl, CLASS_NAMES.hidden);
        svgClasses.addClass(selectedScreenEl, CLASS_NAMES.active);
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/behaviours/changeScreen.js